var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { width: "600px" },
      on: { "on-cancel": _vm.onClose },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "emap-flow-elecseal-container" },
        [
          _c(
            "Tabs",
            {
              attrs: { animated: false },
              model: {
                value: _vm.curTab,
                callback: function ($$v) {
                  _vm.curTab = $$v
                },
                expression: "curTab",
              },
            },
            [
              _vm.elecseal
                ? _c(
                    "TabPane",
                    {
                      attrs: {
                        label: _vm.$LocalH5("sealOrSign.chooseSeal"),
                        name: "elecseal",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "elecsealWrapper",
                          staticClass: "elecseal-wrap",
                        },
                        [
                          _vm.signatureType != "2"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "CheckboxGroup",
                                    {
                                      model: {
                                        value: _vm.sealChecked,
                                        callback: function ($$v) {
                                          _vm.sealChecked = $$v
                                        },
                                        expression: "sealChecked",
                                      },
                                    },
                                    _vm._l(_vm.seals, function (item, key) {
                                      return _c(
                                        "Checkbox",
                                        {
                                          key: key,
                                          staticClass: "seal-item-box",
                                          attrs: {
                                            label: item.WID,
                                            disabled:
                                              _vm.sealChecked.indexOf(
                                                item.WID
                                              ) == -1 && _vm.isMultiple,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "seal-img" },
                                            [
                                              _c("img", {
                                                attrs: { src: item.url },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "seal-label" },
                                            [_vm._v(_vm._s(item.NAME))]
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.esignature
                ? _c(
                    "TabPane",
                    {
                      attrs: {
                        label: _vm.$LocalH5("sealOrSign.chooseSign"),
                        name: "signatrue",
                      },
                    },
                    [
                      _c("div", { staticClass: "signature-wrap" }, [
                        _c("div", { staticClass: "instructions" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$LocalH5("sealOrSign.userDirections")
                              ) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "1、" + _vm._s(_vm.$LocalH5("sealOrSign.text1"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm._v(
                                "2、" + _vm._s(_vm.$LocalH5("sealOrSign.click"))
                              ),
                              _c("Icon", {
                                staticStyle: {
                                  "margin-top": "0px",
                                  "margin-left": "0px",
                                },
                                attrs: {
                                  type: "md-refresh-circle",
                                  size: "16",
                                  color: "#2d8cf0",
                                },
                              }),
                              _vm._v(_vm._s(_vm.$LocalH5("sealOrSign.text2"))),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "3、" + _vm._s(_vm.$LocalH5("sealOrSign.text3"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { "margin-top": "10px" } }, [
                            _vm._v(
                              _vm._s(_vm.$LocalH5("sealOrSign.remark")) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$LocalH5("sealOrSign.text4"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qrcode" }, [
                          _c("div", {
                            staticStyle: { height: "154px" },
                            attrs: { id: _vm.output },
                          }),
                          _vm._v(" "),
                          !_vm.qrcodeDisabled
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#808080",
                                    "font-size": "12px",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$LocalH5("sealOrSign.text5"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.qrcodeDisabled
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#808080",
                                    "font-size": "12px",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _c("Icon", {
                                    staticStyle: { "margin-top": "-2px" },
                                    attrs: { type: "ios-alert", color: "#f90" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$LocalH5("sealOrSign.text6"))
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: { click: _vm.generateQRcode },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$LocalH5("sealOrSign.refresh")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "application" },
                          [
                            _c(
                              "Checkbox",
                              {
                                attrs: { disabled: _vm.signDisabled },
                                model: {
                                  value: _vm.signatureChecked,
                                  callback: function ($$v) {
                                    _vm.signatureChecked = $$v
                                  },
                                  expression: "signatureChecked",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$LocalH5("sealOrSign.electSign"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "signature-refresh",
                                on: { click: _vm.refreshSignature },
                              },
                              [
                                !_vm.signatureLoading
                                  ? _c("Icon", {
                                      staticStyle: {
                                        "margin-top": "0px",
                                        "margin-left": "0px",
                                      },
                                      attrs: {
                                        type: "md-refresh-circle",
                                        size: "24",
                                        color: "#2d8cf0",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.signatureLoading
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          width: "20px",
                                          height: "20px",
                                          background: "#2d8cf0",
                                          "border-radius": "50%",
                                          "text-align": "center",
                                          "margin-left": "2px",
                                        },
                                      },
                                      [
                                        _c("Icon", {
                                          staticClass:
                                            "signature-spin-icon-load",
                                          attrs: {
                                            type: "ios-loading",
                                            size: "12",
                                            color: "#fff",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "signature" }, [
                              _vm.signatureUrl
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        _vm.signatureUrl +
                                        "&_=" +
                                        _vm.timestamp,
                                    },
                                  })
                                : _vm._e(),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { size: "large" }, on: { click: _vm.onClose } },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              attrs: {
                type: "primary",
                size: "large",
                loading: _vm.loading,
                disabled: _vm.btnDisabled,
              },
              on: { click: _vm.okModel },
            },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }